export default __webpack_public_path__ + "static/media/item2.78d6df4d.png";